/* eslint-disable import/no-extraneous-dependencies */
import { BrowserRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';

export const browserHistory = createBrowserHistory();

class Router extends BrowserRouter {
  public history = browserHistory;
}

export default Router;
